import React, { useState } from "react";
import data from "./data";
import SingleQuestion from "./Question";
function App() {
  const [questions, setQuestions] = useState(data);

  return (
    <main>
      <div className="container">
        <h3>questions and answers about login</h3>
        <section className="info">
          {questions.map((question) => {
            return <SingleQuestion key={question.id} title={question.title} info={question.info} />;
          })}
        </section>
      </div>
    </main>
  );
}

export default App;

// https://youtu.be/a_7Z7C_JCyo?t=4994
